import { z } from 'zod'

import { PersonaInfoSummary } from '@/modules/shared/schemas/PersonaInfoSummary'

export const CAAMetrics = z.object({
  availability: z.object({
    percent: z.number(),
    available: z.number(),
    unavailable: z.number()
  }),
  accession: z.object({
    percent: z.number(),
    used: z.number(),
    notUsed: z.number()
  }),
  accessionTherapist: z.object({
    percent: z.number(),
    used: z.number(),
    notUsed: z.number()
  }),
  media: z.number(),
  caa: z.array(
    z.object({
      persona: PersonaInfoSummary,
      amountSessions: z.number(),
      amountModeling: z.number(),
      amountCustomerUse: z.number(),
      accession: z.number(),
      media: z.number(),
      availability: z.number()
    })
  )
})
export type CAAMetrics = z.infer<typeof CAAMetrics>
